"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditFormOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var EditFormOutlineSVG = function EditFormOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29.8 5.11L26.89 2.2a.67.67 0 00-.48-.2.7.7 0 00-.49.2L21.13 7H4a2 2 0 00-2 2v19a2 2 0 002 2h19a2 2 0 002-2V10.88l4.8-4.8a.68.68 0 000-.97zM23 28H4V9h15.13l-3.5 3.5-4 4a.42.42 0 00-.14.28L11 20.22a.69.69 0 00.19.58.68.68 0 00.49.2l3.54-.5a.42.42 0 00.28-.14l7.5-7.48zm-8.55-9.41l-1.22.18.18-1.22L23.83 7.13l1 1zM26.23 6.82l-1.05-1 1.3-1.3 1.05 1z"
  }));
};
exports.EditFormOutlineSVG = EditFormOutlineSVG;
EditFormOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(EditFormOutlineSVG);
exports.default = _default;